module.exports = __webpack_public_path__ + "fonts/ProximaNovaCondensedW05-It.fd07f7d7.ttf";